import { connect } from 'react-redux';
import { loadItems, clearState } from '@Pages/RetroSynthesis/components/RsSlidablePaginated/actions';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_RS_SLIDABLE_PAGINATED } from '@Pages/RetroSynthesis/components/RsSlidablePaginated/constants';
import RsSlidablePaginated from './RsSlidablePaginatedBase';

function mapStateToProps(state) {
  const rsState = state && state.get && state.get(REDUCER_KEY_RS);
  const { items, totalElements, totalPages, loadedPages, partialLastPageLoaded, reloadToItem } =
    rsState.get(REDUCER_KEY_RS_SLIDABLE_PAGINATED);
  return {
    items,
    totalElements,
    totalPages,
    loadedPages,
    partialLastPageLoaded,
    reloadToItem,
  };
}

const mapDispatchToProps = {
  loadItems,
  clearState,
};

export default connect(mapStateToProps, mapDispatchToProps)(RsSlidablePaginated);
